import React from 'react';
export function MatrixE3Section() {
  return <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden mb-12 transition-shadow hover:shadow-lg" data-id="element-1413">
      <div className="flex flex-col md:flex-row" data-id="element-1414">
        <div className="md:w-5/12 p-8 flex items-center justify-center bg-gray-50 border-b md:border-b-0 md:border-r border-gray-100" data-id="element-1415">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Breton%20Matrix%20E3.png" alt="MATRIX E3" className="block max-w-full h-auto object-contain max-h-[300px]" data-id="element-1416" />
        </div>
        <div className="md:w-7/12 p-8 flex flex-col" data-id="element-1417">
          <h3 className="text-3xl font-bold text-[#9B0137] uppercase tracking-tight mb-2" data-id="element-1418">
            MATRIX E3
          </h3>
          <h4 className="text-lg font-semibold text-navy mb-4 leading-snug" data-id="element-1419">
            High Dynamic and High Precision 5-axis Modular Vertical Gantry
            Machining Center
          </h4>
          <div className="text-gray-700 mb-6 flex-grow space-y-4" data-id="element-1420">
            <p className="leading-relaxed" data-id="element-1421">
              The development of this machining center was based on careful
              technical choices that combine thrust and robustness with dynamics
              and precision for perfect performance in hi-feed{' '}
              <strong data-id="element-1422">
                roughing, semi-finishing and finishing of medium-large
                workpieces in steel, lightweight alloys, and special composites.
              </strong>
            </p>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 text-sm" data-id="element-1423">
              <strong className="text-navy block mb-2" data-id="element-1424">Travels (X,Y,Z):</strong>
              <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-1425">
                <li data-id="element-1426">X: 118 - 1181 in.</li>
                <li data-id="element-1427">Y: 118 / 157 in.</li>
                <li data-id="element-1428">Z: 51 / 59 in.</li>
              </ul>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-auto pt-4 border-t border-gray-100" data-id="element-1429">
            <a href="https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=Breton%20Matrix%20E3" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1430">
              <span className="mr-2" data-id="element-1431">+</span> Request Quote
            </a>
            <a href="https://www.breton.it/products/machines-and-lines/breton-matrix-e3" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1432">
              <span className="mr-2" data-id="element-1433">+</span> Additional Information
            </a>
          </div>
        </div>
      </div>
    </div>;
}